import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
// pages
import MainPage from '@view/pages/Main';
// components
import { PageLoader } from '@view/components/Loader/PageLoader';
import { PageNotFoundRedirect } from '@view/components/PageNotFoundRedirect';
// constants
import { ROOT_CLASSNAME, ROOT_ID } from '@view/constants/root';
// business
import { eventSystem } from '@business/event-system';
// hooks
import { useApplicationFlow } from '@view/hooks/useApplicationFlow';
// config
import { system } from '@config/system';
// theme
import { ROOT_HEIGHT_PROPERTY } from '@theme/root-styles';
import { Routes as AppRoutes } from '../routes';
const NotFoundPage = React.lazy(() => import(/* webpackChunkName: "not-found" */ '@view/pages/Errors/NotFound'));
const Property = React.lazy(() => import(/* webpackChunkName: "property" */ '@view/pages/Property'));
const createDevRoutes = [
    'localhost',
    '127.0.0.1',
    'booking-engine.cloudbeds.com',
    'booking-engine.cloudbeds-dev.com',
    'booking-engine.cloudbeds-stage.com',
].indexOf(window.location.hostname) > -1;
/**
 * The router shell. It initializes nothing: `Property` matches the whole
 * `/reservation/:propertyCode/*` subtree — booking funnel and standalone legal
 * pages alike — and splits it internally, each side running its own prologue.
 */
const Root = () => {
    const { currentPage: page } = useApplicationFlow();
    const location = useLocation();
    // @TECHDEBT: Why are we blocking double click on the whole app?
    useEffect(() => {
        if (system.isImmersiveExperience) {
            return;
        }
        const handleMouseDown = (event) => {
            if (event.detail > 1) {
                event.preventDefault();
            }
        };
        /* preventing select text on double click */
        document.addEventListener('mousedown', handleMouseDown, false);
        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);
    // Track route changes for analytics
    useEffect(() => {
        const query = Object.fromEntries(new URLSearchParams(location.search));
        eventSystem.emit('route-loaded', {
            page,
            query,
            route: location.pathname,
        }, { visibility: 'external' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);
    return (
    // `position="relative"` is the positioned ancestor the contained variant of
    // BookingUnavailableCard measures itself against — do not drop it.
    _jsx(Box, { className: ROOT_CLASSNAME, id: ROOT_ID, position: "relative", children: _jsx(Box, { sx: { [ROOT_HEIGHT_PROPERTY]: '100%' }, children: _jsx(Suspense, { fallback: _jsx(PageLoader, { testid: "root-loader" }), children: _jsxs(Routes, { children: [createDevRoutes && _jsx(Route, { element: _jsx(MainPage, {}), path: "/" }), _jsx(Route, { element: _jsx(NotFoundPage, {}), path: "/404" }), _jsx(Route, { element: _jsx(Property, {}), path: `${AppRoutes.Property}/*` }), _jsx(Route, { element: _jsx(Property, {}), path: `${AppRoutes.PropertyBr}/*` }), _jsx(Route, { element: _jsx(Property, {}), path: `/:lang${AppRoutes.Property}/*` }), _jsx(Route, { element: _jsx(Property, {}), path: `/:lang${AppRoutes.PropertyBr}/*` }), _jsx(Route, { element: _jsx(PageNotFoundRedirect, {}), path: "*" })] }) }) }) }));
};
export default observer(Root);
